import { Layers } from "lucide-react";

export const CategoryCard = ({ category, onClick }) => {
  // We use the first 3 images to create the stack effect
  const [topImg, midImg, botImg] = category.images;

  return (
    <div
      onClick={() => onClick(category)}
      className="group relative w-full cursor-pointer flex flex-col items-center"
    >
      {/* The Stack Container */}
      <div className="relative w-full aspect-[4/3] mb-6 perspective-500">
        {/* Bottom Card (Furthest back) */}
        <div className="absolute inset-0 z-0 transform transition-all duration-500 ease-out group-hover:translate-x-6 group-hover:-translate-y-2 group-hover:rotate-6 opacity-60">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg border border-slate-700 bg-slate-800">
            <img
              src={botImg || topImg}
              alt=""
              className="w-full h-full object-cover grayscale brightness-50"
            />
          </div>
        </div>

        {/* Middle Card */}
        <div className="absolute inset-0 z-10 transform transition-all duration-500 ease-out group-hover:-translate-x-6 group-hover:-translate-y-1 group-hover:-rotate-3 opacity-80">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg border border-slate-700 bg-slate-800">
            <img
              src={midImg || topImg}
              alt=""
              className="w-full h-full object-cover grayscale brightness-75"
            />
          </div>
        </div>

        {/* Top Card (Main) */}
        <div className="absolute inset-0 z-20 transform transition-all duration-300 ease-out group-hover:-translate-y-4 group-hover:scale-105">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-600 bg-slate-800 relative">
            <div className="absolute inset-0 bg-slate-900/10 group-hover:bg-transparent transition-colors duration-300" />
            <img
              src={topImg}
              alt={category.name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            {/* Corner Badge */}
            <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-md text-white text-xs font-medium px-2 py-1 rounded-md flex items-center gap-1 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity delay-100">
              <Layers className="w-3 h-3" />
              {category.count}
            </div>
          </div>
        </div>
      </div>

      {/* Category Name */}
      <div className="text-center relative z-30">
        <h3 className="text-xl font-bold text-slate-200 group-hover:text-indigo-400 transition-colors">
          {category.name}
        </h3>
        <p className="text-sm text-slate-500 group-hover:text-slate-400 transition-colors">
          {category.count} items
        </p>
      </div>
    </div>
  );
};

export default CategoryCard;
